class WaypointSubscriptionEnhancer extends HTMLElement {
  connectedCallback() {
    this.observer = new MutationObserver(() => this.enhance());
    this.observer.observe(document.documentElement, { childList: true, subtree: true });
    this.enhance();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  enhance() {
    const widget = document.querySelector('[id^="appstle_subscription_widget"]');
    if (!widget) return;

    const title = widget.querySelector('.appstle_tooltip_title');
    if (title && this.dataset.title && title.textContent !== this.dataset.title) {
      title.textContent = this.dataset.title;
    }

    const learnLink = widget.querySelector('.appstle_subcription_link');
    if (learnLink && this.dataset.linkLabel && this.dataset.linkUrl) {
      if (learnLink.textContent !== this.dataset.linkLabel) {
        learnLink.textContent = this.dataset.linkLabel;
      }
      if (learnLink.getAttribute('href') !== this.dataset.linkUrl) {
        learnLink.href = this.dataset.linkUrl;
      }
      learnLink.removeAttribute('target');
      learnLink.removeAttribute('rel');
    }

    const branding = widget.querySelector('.appstle_link');
    if (branding && this.dataset.hideBranding === 'true') branding.hidden = true;

    this.renderSavings(widget);

    if (widget.dataset.waypointTracking !== 'true') {
      widget.dataset.waypointTracking = 'true';
      widget.addEventListener('change', () => this.publishSelection(widget));
    }
  }

  renderSavings(widget) {
    const oneTime = this.moneyValue(widget.querySelector('.appstle_one_time_price_wrapper'));
    const subscription = this.moneyValue(
      widget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount'),
    );
    if (oneTime === null || subscription === null || oneTime <= subscription) return;

    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format(oneTime - subscription);
    const message = (this.dataset.savingsTemplate || '[amount]').replace('[amount]', amount);
    let savings = widget.querySelector('.waypoint-subscription__savings');
    if (!savings) {
      savings = document.createElement('p');
      savings.className = 'waypoint-subscription__savings';
      widget.append(savings);
    }
    if (savings.textContent !== message) savings.textContent = message;
  }

  moneyValue(node) {
    if (!node) return null;
    const normalized = node.textContent.replace(/[^0-9.,-]/g, '').replace(',', '.');
    const amount = Number.parseFloat(normalized);
    return Number.isFinite(amount) ? amount : null;
  }

  publishSelection(widget) {
    const selected = widget.querySelector('input[type="radio"]:checked');
    const purchaseType = selected?.closest('.appstle_one_time_details_wrapper')
      ? 'one_time'
      : 'subscription';
    const detail = {
      productId: this.dataset.productId,
      variantId: document.querySelector('[data-variant-id]')?.value || '',
      purchaseType,
    };
    document.dispatchEvent(new CustomEvent('waypoint:subscription-option-change', { detail }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'waypoint_subscription_option_change', ...detail });
    }
    this.publishShopifyEvent('waypoint:subscription_option_change', detail);
  }

  publishShopifyEvent(eventName, detail) {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    const result = publish.call(window.Shopify.analytics, eventName, detail);
    result?.catch?.((error) => {
      console.warn(`Unable to publish ${eventName}`, error);
    });
  }
}

if (!customElements.get('waypoint-subscription-enhancer')) {
  customElements.define('waypoint-subscription-enhancer', WaypointSubscriptionEnhancer);
}
